<div
  class="custom-spinner spinner-container"
  role="alert"
  aria-live="assertive"
  aria-busy="true"
  aria-label="Loading, please wait"
  [style.width]="size"
  [style.height]="size"
  [style.display]="display"
  [style.--spinner-color]="color"
  [style.--spinner-thickness]="thickness"
></div>
